import CommonMapper from '@/modules/core/mappers/CommonMapper'

import SaveDocumentRequest from '@/modules/common/hiring/models/MID/requests/SaveDocumentRequest'
import { fileToBase64 } from '@/utils/converterUtils'
import type Insured from '@/modules/common/common/models/APP/Insured'

export default class SaveDocumentMapper {
  static async toRequest<I extends Insured = Insured>(
    quotationId: string,
    holder: I
  ): Promise<SaveDocumentRequest> {
    const documentExpirationDate = holder.documentDetails.documentExpirationDate
    const file = holder.documentDetails.file
    const documentData = file ? await fileToBase64(file) : undefined
    const document = documentData
      ? [
          {
            fileName: holder.documentDetails.fileName,
            documentType: '1',
            documentData,
            riskNumber: String(holder.riskNumber)
          }
        ]
      : []

    return new SaveDocumentRequest({
      quotationId,
      document: document,
      policyHolder: {
        role: holder.role,
        nacionality: holder.addressDetails.country,
        personType: holder.documentDetails.personType,
        documentType: holder.documentDetails.documentType,
        documentNumber: holder.documentDetails.documentNumber,
        documentExpirationDate: documentExpirationDate
          ? CommonMapper.toMiddlewareDate(documentExpirationDate)
          : undefined,
        privacyPolicyConsent: holder.privacyPolicyConsent,
        birthDate: CommonMapper.toMiddlewareDate(holder.userDetails.birthDate)
      }
    })
  }
}
